export const APP_NAME = 'one-time-links';
